import { Component, OnInit } from '@angular/core';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-new-reviews',
  templateUrl: './new-reviews.component.html',
  styleUrls: ['./new-reviews.component.scss']
})
export class NewReviewsComponent implements OnInit {
  feedback: any;
  current_module: any;
  public stars: any[] = new Array(5);
  review_length: any = 0;

  constructor(
    private auth: AuthServiceService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((res: any) => {
      this.current_module = res.id;
      this.getFeedback(res.id);
    });
  }

  getFeedback(module) {
    let formData = new FormData();
    formData.append('current_module', module);

    this.auth.get_all_feedback_module(formData).subscribe((response: any) => {
      (response)
        ? this.feedback = response.body
        : this.feedback = [];
      this.review_length = response.body.length;
    });
  }

}
